import * as React from 'react'
import styled from 'styled-components'

import * as S from '../styles'

export type ProgressBarProps = {
  data?: string
  showPercentage?: boolean
  width: number
}

function ProgressBarComponent({ data, showPercentage, width }: ProgressBarProps): React.ReactElement<ProgressBarProps> {
  return (
    <S.progressBar.ProgressBarContainer>
      <S.progressBar.ProgressBar $value={width} />
      {data ? (
        <S.progressBar.ProgressBarText dangerouslySetInnerHTML={{ __html: data }} />
      ) : showPercentage ? (
        <S.progressBar.ProgressBarText>{width}%</S.progressBar.ProgressBarText>
      ) : null}
    </S.progressBar.ProgressBarContainer>
  )
}

export const ProgressBar = styled(ProgressBarComponent)<ProgressBarProps>``
